import { S, Icon } from '../regureStyles';

const SummaryCards = ({ reports, submitted, pending, dueThisMonth }) => {
  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16, marginBottom: 28 }}>
      {[
        { label: 'Total Reports', value: reports.length, icon: 'file-text', color: S.info },
        { label: 'Submitted', value: submitted, icon: 'check-circle', color: S.success },
        { label: 'Pending', value: pending, icon: 'bell', color: S.warning },
        { label: 'Due This Month', value: dueThisMonth, icon: 'shield', color: S.burgundy },
      ].map((card, i) => (
        <div
          key={i}
          style={{ background: '#fff', border: `1px solid ${S.borderLight}`, borderRadius: 10, padding: '20px 24px', display: 'flex', alignItems: 'center', gap: 16 }}
        >
          <div style={{ width: 44, height: 44, borderRadius: 10, background: `${card.color}15`, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Icon name={card.icon} size={20} color={card.color} />
          </div>
          <div>
            <div style={{ fontSize: 24, fontWeight: 700, color: S.textPrimary }}>{card.value}</div>
            <div style={{ fontSize: 12, color: S.textMuted, marginTop: 2 }}>{card.label}</div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SummaryCards;
